import { create } from 'zustand';

interface UserState {
  tgId?: number;
  username?: string;
  isAdmin: boolean;
  adminsLoaded?: number;
  activeOrderId?: number | null;
  lang: 'ru' | 'uz';
  setUser: (u: {
    tgId: number;
    username?: string;
    isAdmin: boolean;
    adminsLoaded?: number;
    activeOrderId?: number | null;
    lang: 'ru' | 'uz';
  }) => void;
}

export const useUserStore = create<UserState>((set) => ({
  isAdmin: false,
  lang: 'ru',
  setUser: ({ tgId, username, isAdmin, adminsLoaded, activeOrderId, lang }) =>
    set({ tgId, username, isAdmin, adminsLoaded, activeOrderId, lang }),
}));
